const marqueeSection = document.querySelector('.marquee-section');

const cardProduct = document.querySelectorAll('.card-product');

const productQuantityAdd = document.querySelector(".product-qty-container .qty-add");
const productQuantityMinus = document.querySelector(".product-qty-container .qty-minus");
const productQuantityInput = document.querySelector(".product-qty-container input");

const mobileNavOverlay = document.querySelector('.mobile-nav-overlay');
const navCloser = document.querySelector('.site-header__icons-wrapper button');
if(mobileNavOverlay) {
  mobileNavOverlay.addEventListener("click", () => {
	navCloser.click();                       
  });
}

if(productQuantityAdd) {
  productQuantityAdd.addEventListener('click', () => {
       productQuantityInput.value = +productQuantityInput.value + 1;                              
});
  
  productQuantityMinus.addEventListener('click', () => {
	if(productQuantityInput.value > 1) {
    	productQuantityInput.value = +productQuantityInput.value - 1;    
  	}
  });
}


if (cardProduct.length) {

    const productGridParents = document.querySelectorAll(".product-index-grid");

    if (productGridParents.length) {
        productGridParents.forEach(gridParent => {
            const scrollLeftIcon = gridParent.querySelector('.scroll_icon.left');
            const scrollRightIcon = gridParent.querySelector('.scroll_icon.right');

            if (scrollLeftIcon) {
                scrollLeftIcon.addEventListener('click', () => {
                    gridParent.scrollLeft = Math.round(gridParent.scrollLeft - (document.body.offsetWidth / 2));
                });
            }

            if (scrollRightIcon) {
                scrollRightIcon.addEventListener('click', () => {
                    gridParent.scrollLeft = Math.round(gridParent.scrollLeft + (document.body.offsetWidth / 2));
                });
            }
        });
    }

    cardProduct.forEach(product => {
        const productForm = product.querySelector('form');
        const cardSwatches = product.querySelectorAll('.swatch-element.color input');
        const prodSelect = product.querySelector('select[name="id"]');
        if (productForm) {
            productForm.addEventListener('change', () => {
                let txt = "";
                let i;
                for (i = 0; i < productForm.length; i++) {
                    let proElements = productForm.elements[i];
                    if (proElements.classList.contains('form-data')) {
                        if ((proElements.type === 'radio') && proElements.checked) {
                            txt = txt === "" ? proElements.value : txt + ' / ' + proElements.value;

                        }

                        if ((proElements.type === 'select-one')) {
                            txt = txt === "" ? proElements.value : txt + ' / ' + proElements.value;
                        }
                    }
                };
          		const prodOption = prodSelect.querySelector(`[data-value="${txt}"]`);
          		prodOption ? prodOption.selected = true : false;
                const productImage = product.querySelector(`[data-title="${txt}"]`);
                const activeImage = product.querySelector('img.active');
                if (productImage !== activeImage) {
                  productImage.classList.add('active');
                  activeImage.classList.remove('active');
                }          
            })
        }
//         if (cardSwatches.length) {
//             console.log(cardSwatches);
//             cardSwatches.forEach((swatch, swatchIndx) => {
//                 swatch.addEventListener('change', () => {
//                     prodSelect[swatchIndx].selected = true;
//                     const productImage = product.querySelector(`[data-title="${swatch.value}"]`);
//                     const activeImage = product.querySelector('img.active');
//                     if (productImage !== activeImage) {
//                         productImage.classList.add('active');
//                         activeImage.classList.remove('active');
//                     }
//                 });
//             })
//         }
    })
}



const headerEl = document.querySelector('#shopify-section-header')
const announcmentBar = document.querySelector("div#shopify-section-announcment");


if(announcmentBar && headerEl) {
  
  const headerTop = headerEl.querySelector('header.site-header.logo--center');
  const handler = (entries) => {
    // entries is an array of observed dom nodes
    // we're only interested in the first one at [0]
    // because that's our .sentinal node.
    // Here observe whether or not that node is in the viewport
    if (!entries[0].isIntersecting) {
      headerEl.style.transform = `translatey(-${headerTop.offsetHeight}px)`
      headerEl.classList.add('enabled')
    } else {
      headerEl.style.transform = `translatey(0)`
      headerEl.classList.remove('enabled')
    }
  }

  // create the observer
  const observer = new window.IntersectionObserver(handler)
  // give the observer some dom nodes to keep an eye on
  observer.observe(announcmentBar)
}

const siteItemInner = document.querySelectorAll(".site-footer__item-inner--link_list");

if(siteItemInner.length) {
  if(document.body.offsetWidth < 769) {
    siteItemInner.forEach(items => { 
    	const itemTitle = items.querySelector(".h4");
      	itemTitle.innerHTML = itemTitle.innerHTML + '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-down" viewBox="0 0 9 9"><path d="M8.542 2.558a.625.625 0 0 1 0 .884l-3.6 3.6a.626.626 0 0 1-.884 0l-3.6-3.6a.625.625 0 1 1 .884-.884L4.5 5.716l3.158-3.158a.625.625 0 0 1 .884 0z" fill="#fff"/></svg>';
      	const linkList = items.querySelector(".site-footer__linklist");
      	linkList.dataset.maxHeight = linkList.offsetHeight + 'px';
      	linkList.style.maxHeight = 0; 
        itemTitle.addEventListener("click", () => {
                if (linkList.style.maxHeight === '0px') {
                    linkList.style.maxHeight = linkList.dataset.maxHeight;
          			items.classList.add('active');
                } else {
					linkList.style.maxHeight = 0; 
                  	items.classList.remove('active');
                }
		});
    })
  }
}

    const collectionList = document.querySelectorAll(".slider-mobile-gutter");

    if (collectionList.length) {
        collectionList.forEach(gridParent => {
          const gridUl = gridParent.querySelector('ul');
            const scrollLeftIcon = gridParent.querySelector('.slider-button--prev');
            const scrollRightIcon = gridParent.querySelector('.slider-button--next');
            if (scrollLeftIcon) {
                scrollLeftIcon.addEventListener('click', () => {
                    gridUl.scrollLeft = Math.round(gridUl.scrollLeft - (document.body.offsetWidth / 2));
                });
            }

            if (scrollRightIcon) {
                scrollRightIcon.addEventListener('click', () => {
                    gridUl.scrollLeft = Math.round(gridUl.scrollLeft + (document.body.offsetWidth / 2));
                });
            }
        });
    }
    
    const sliderTop = document.querySelector('#shopify-section-header');
	
if(sliderTop) {
  if(document.querySelector('.index-section')) {
    document.querySelector('.index-section').style.paddingTop = sliderTop.offsetHeight + "px"; 
  } else {
  	document.querySelector('#PageContainer').style.paddingTop = sliderTop.offsetHeight + "px"; 
  }
}
	